import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  type ElementRef,
  EventEmitter,
  Input,
  Output,
  viewChild,
} from '@angular/core';

import { HeaderBrandComponent } from '../header-brand/header-brand.component';

/** Le scritte della schermata, gia' tradotte: un componente shared non traduce. */
export interface ServiceUnavailableLabels {
  readonly brandName: string;
  readonly title: string;
  readonly message: string;
  /** L'unica cosa che la persona puo' fare da qui: riprovare, o uscire. */
  readonly action: string;
}

/**
 * La schermata di portale momentaneamente non disponibile. Copre tutto, intestazione compresa, e ne
 * porta una propria: puo' comparire prima che una cornice sia montata — una guardia che non ha avuto
 * risposta non apre nessuna rotta — e dietro c'e' una pagina rimasta a meta', che non va toccata.
 *
 * Non dice cosa si e' rotto: a chi usa il portale basta sapere che non e' colpa sua e che puo' riprovare.
 * La stessa schermata dice anche all'operatore che su questo ente non e' abilitato: anche li' la postazione
 * non si apre, e resta una sola azione — uscire.
 */
@Component({
  selector: 'dxp-service-unavailable',
  standalone: true,
  imports: [HeaderBrandComponent],
  templateUrl: './service-unavailable.component.html',
  styleUrl: './service-unavailable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceUnavailableComponent {
  @Input({ required: true }) labels!: ServiceUnavailableLabels;

  /** Il marchio del tenant per il riquadro chiaro della barra, o `null` per le iniziali del portale (#1850). */
  @Input() markUrl: string | null = null;

  @Output() readonly actionRequested = new EventEmitter<void>();

  private readonly title = viewChild.required<ElementRef<HTMLElement>>('title');

  constructor() {
    // Il fuoco si sposta sul titolo: chi usa un lettore di schermo stava su un comando che ora e' sotto
    // la schermata, inerte, e da li' non sentirebbe niente.
    afterNextRender(() => this.title().nativeElement.focus());
  }

  protected onActionClick(): void {
    this.actionRequested.emit();
  }
}
